import { schema } from 'normalizr'

const portsByCodeSchema = new schema.Entity('ports', {}, { idAttribute: 'code' })

export const portsSchema = new schema.Array(portsByCodeSchema)
